import { useCallback, useEffect, useState } from 'react'

import {
  consumeLeadGateBypassParam,
  grantLeadGateAccess,
  hasLeadGateAccess,
  type LeadGateUnlock,
  reportLeadGateUnlock,
} from './leadGateAccess'

/* `isResolved` is false until localStorage has been read after hydration.
   With an `unlock`, a visitor who already has access (from another gate)
   still gets this content's unlock reported to Loops. */
export function useLeadGateAccess(unlock?: LeadGateUnlock) {
  const [hasAccess, setHasAccess] = useState(false)
  const [isResolved, setIsResolved] = useState(false)

  useEffect(() => {
    setHasAccess(consumeLeadGateBypassParam() || hasLeadGateAccess())
    setIsResolved(true)
  }, [])

  const unlockSource = unlock?.source
  const unlockContentSlug = unlock?.contentSlug
  useEffect(() => {
    if (!hasAccess || !unlockSource || !unlockContentSlug) return
    void reportLeadGateUnlock({
      source: unlockSource,
      contentSlug: unlockContentSlug,
    })
  }, [hasAccess, unlockSource, unlockContentSlug])

  const grantAccess = useCallback(() => {
    grantLeadGateAccess()
    setHasAccess(true)
  }, [])

  return { hasAccess, isResolved, grantAccess }
}
